import { createFileRoute } from '@tanstack/react-router';
import { ResourceHub } from '../../components/resources/ResourceHub';
import { useSEO, useBreadcrumbSchema, PageSEO } from '../../lib/seo';

export const Route = createFileRoute('/resources/')({
  component: ResourcesPage,
  validateSearch: (search: Record<string, unknown>) => {
    const validTypes = ['all', 'blog', 'research', 'case-study'];
    return {
      type: typeof search.type === 'string' && validTypes.includes(search.type) ? search.type : undefined,
      q: typeof search.q === 'string' ? search.q : undefined,
    };
  },
});

function ResourcesPage() {
  useSEO(PageSEO.resources);
  useBreadcrumbSchema([
    { name: 'Home', url: '/' },
    { name: 'Resources', url: '/resources' },
  ]);

  return <ResourceHub />;
}
